module.exports = __webpack_public_path__ + "static/img/download_back4.cca425c8.png";